import { createSlice } from "@reduxjs/toolkit";
import { getAllAds } from "./thunk";

const initialState = {
  ads: [],
  loading: false,
  error: null,
};

const adsSlice = createSlice({
  name: "adsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL ADS
    builder
      .addCase(getAllAds.pending, (state) => {
        state.loading = true;
        state.ads = [];
        state.error = null;
      })
      .addCase(getAllAds.fulfilled, (state, action) => {
        state.loading = false;
        state.ads = action.payload?.data;
      })
      .addCase(getAllAds.rejected, (state, action) => {
        state.loading = false;
        state.ads = [];
        state.error = action.error.message;
      });

    },
});

export default adsSlice.reducer;